export default __webpack_public_path__ + "static/4-6ab4d34a33ac33d06d72524a1af28de7.svg";